<template>
  <div ref="target" :class="isSquare ? 'aspect-square' : 'aspect-video'">
    <lite-youtube
      v-if="data.provider === 'youtube'"
      :playlabel="$t('media.play')"
      :videoid="`${data.providerUid}`"
      :style="{
        backgroundImage: `url(https://i.ytimg.com/vi/${data.providerUid}/hqdefault.jpg)`
      }"
      class="w-full h-full"
      :class="isRounded ? 'rounded-[20px] lg:rounded-[40px]' : ''"
    >
    </lite-youtube>
    <iframe
      v-else-if="data.provider === 'vimeo'"
      :src="`https://player.vimeo.com/video/${data.providerUid}`"
      width="640"
      height="360"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
      class="w-full h-full"
      :class="isRounded ? 'rounded-[20px] lg:rounded-[40px]' : ''"
    ></iframe>
  </div>
</template>

<script setup lang="ts">
defineProps({
  data: {
    type: Object,
    default: () => {}
  },
  isSquare: {
    type: Boolean,
    default: false
  },
  isRounded: {
    type: Boolean,
    default: false
  }
})

const target = ref(null)
const isVisible = ref(false)

const { stop } = useIntersectionObserver(
  target,
  ([{ isIntersecting }], _observerElement) => {
    if (isIntersecting) {
      isVisible.value = true
    }
  },
  {
    threshold: 0.5
  }
)

onUnmounted(() => {
  stop()
})
</script>

<style lang="postcss">
lite-youtube {
  @apply border-2 border-black;

  background-color: #000;
  position: relative;
  display: block;
  contain: content;
  background-position: center center;
  background-size: cover;
  cursor: pointer;
  max-width: none;
}

lite-youtube::before {
  @apply h-full w-full bg-black bg-opacity-50 p-0;
  background-image: none;
}

lite-youtube::after {
  display: none;
}

/* play button */
lite-youtube .lty-playbtn {
  filter: none;

  @screen lg {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-position: left 24px center;
    background-repeat: no-repeat;
    background-size: 20px;
    position: absolute;
    cursor: pointer;
    transform: translate3d(-50%, -50%, 0);
    top: 50%;
    left: 50%;
    z-index: 1;
    background-image: url('~/assets/images/icons/svg/polygon.svg');
    transition: filter 0.1s cubic-bezier(0, 0, 0.2, 1);
    border: none;
    background-color: white;
  }
}

lite-youtube:hover > .lty-playbtn,
lite-youtube .lty-playbtn:focus {
  filter: none;
}

/* Post-click styles */
lite-youtube.lyt-activated {
  cursor: unset;
}
lite-youtube.lyt-activated::before,
lite-youtube.lyt-activated > .lty-playbtn {
  opacity: 0;
  pointer-events: none;
}

.lyt-visually-hidden {
  @apply sr-only;
}
</style>
